import { render, staticRenderFns } from "./ShopSummary.vue?vue&type=template&id=5afbd298&"
import script from "./ShopSummary.vue?vue&type=script&lang=js&"
export * from "./ShopSummary.vue?vue&type=script&lang=js&"
import style0 from "./ShopSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports